<template>
  <a-modal
    centered
    title="待确认菜品"
    v-model="visible"
    width="900px"
    :maskClosable="false"
    :destroyOnClose="true"
    @cancel="visible = false"
  >
    <template slot="footer">
      <!-- <a-popconfirm
        title="确定取消菜品吗?"
        ok-text="确定"
        cancel-text="取消"
        @confirm="cancelDishs"
      >
        <a-button class="cancel-btn">取消菜品</a-button>
      </a-popconfirm> -->
      <a-button type="primary" @click="confirmDishs" :loading="loading"
        >确认</a-button
      >
    </template>
    <data-grid
      class="food-table-list"
      ref="foodsTable"
      size="middle"
      :columns="orderColumns"
      v-model="foodList"
      :pagination="false"
      :rowSelect="true"
      :rowTriggerSelect="true"
      :props="props"
      rowKey="Id"
    >
      <template slot="name" slot-scope="text, row">
        <div class="food-title multi-line" style="text-align:left;">
          <div>
            <span class="icon-list">
              <i
                v-if="row.Id"
                class="icon-text"
                style="background:rgb(135, 208, 104);color:#fff;"
                ><a-icon type="check"
              /></i>
              <i
                v-if="!row.Id"
                class="icon-text"
                style="background:#1890ff;color:#fff;"
                ><a-icon type="plus"
              /></i>
              <a-popover placement="bottomLeft" title="套餐菜品">
                <template slot="content">
                  <div
                    v-for="foodItem in row.PackDetails"
                    :key="foodItem.Id"
                    class="flex"
                  >
                    <div class="flex-item">{{ foodItem.Name }}</div>
                    <div>{{ foodItem.Quantity }}</div>
                  </div>
                </template>
                <i
                  v-if="row.IsPack"
                  class="icon-text"
                  style="background:#f90;color:#fff;cursor: pointer;"
                  >套</i
                >
              </a-popover>
            </span>
            {{ text }}
          </div>
          <div
            v-if="row.PracticeDesc || row.CookingMethodDesc"
            class="text-less"
          >
            「做法」{{ row.PracticeDesc }}{{ row.CookingMethodDesc }}
          </div>
        </div>
      </template>
    </data-grid>
  </a-modal>
</template>
<script>
import { DataGrid } from "@/components/dataGrid";
import "./rms.less";
export default {
  components: { DataGrid },
  data() {
    return {
      visible: false,
      orderId: "",
      foodList: [],
      props: {
        scroll: { x: false, y: "calc(100vh - 300px)" }
      },
      orderColumns: [
        {
          title: "菜名",
          dataIndex: "AccountItemName",
          scopedSlots: { customRender: "name" },
          align: "left"
        },
        {
          title: "桌台",
          dataIndex: "TableName",
          width: 100
        },
        {
          title: "数量",
          dataIndex: "Quantity",
          width: 80,
          align: "center"
        },
        {
          title: "单价",
          dataIndex: "UnitPrice",
          width: 80,
          align: "center"
        },
        {
          title: "金额",
          dataIndex: "TotalPrice",
          width: 80,
          align: "center"
        },
        {
          title: "折扣",
          dataIndex: "DiscountPrice",
          width: 80,
          align: "center"
        },
        {
          title: "核算金额",
          dataIndex: "FinalPrice",
          width: 100,
          align: "center"
        }
      ],
      loading: false
    };
  },

  created() {},
  methods: {
    show(orderId, data, orderData) {
      this.visible = true;
      this.orderId = orderId;
      if (orderData) {
        this.foodList = [];
        for (let i = 0; i < orderData.DishTables.length; i++) {
          const item = orderData.DishTables[i];
          const arr = item.DishAccounts.filter(el => el.Id && el.IsUnconfirmed);
          this.foodList = this.foodList.concat(arr);
        }
      } else {
        this.foodList = data.filter(el => el.Id && el.IsUnconfirmed);
      }
      // this.foodList = data.filter(el => el.Id && el.IsUnconfirmed);
      const ids = this.foodList.map(v => v.Id);
      this.$nextTick(() => {
        this.$refs.foodsTable.setSelecteds(ids);
      });
    },
    confirmDishs() {
      this.onSubmit(true);
    },
    cancelDishs() {
      this.onSubmit(false);
    },
    onSubmit() {
      const selecteds = this.$refs.foodsTable.getSelecteds();
      let selectedKeys = [];
      if (selecteds && selecteds.length) {
        selectedKeys = selecteds.map(v => v.Id);
      }

      // if (!selecteds || !selecteds.length) {
      //   this.$message.error("请选择菜品");
      //   return false;
      // }
      const accounts = this.foodList.map(v => {
        return {
          AccountId: v.Id,
          IsConfirm: selectedKeys.includes(v.Id)
        };
      });
      this.loading = true;
      const _this = this;
      this.$post(
        "ConfirmDishAsync",
        {
          OrderId: this.orderId,
          Accounts: accounts
        },
        { alertError: false }
      )
        .then(() => {
          this.visible = false;
          this.$message.success("操作成功");
          this.$emit("update");
          this.loading = false;
        })
        .catch(error => {
          if (error.data && error.data.Code == 2) {
            this.$info({
              title: "确认菜品成功",
              content: () => <div style="color:#f60">{error.data.Message}</div>,
              onOk() {
                _this.visible = false;
                _this.$emit("update");
              }
            });
          } else {
            const text =
              error.data && error.data.Message
                ? error.data.Message
                : "后台发生错误！";
            _this.$message.error(text, 5);
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.food-table-list /deep/.un-checked-row .ant-checkbox:after {
  content: "x";
  width: 100%;
  height: 100%;
  color: #fff;
  background: #f00;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
